// The one-time, dismissible "the owner reset their encryption" notice a
// PARTNER sees when their browser had pinned the owner's pre-reset
// transparency head (OWNER-RESET.md §14.4; user decision 2026-09-24, "option
// C": dismissible, shown only in a browser that actually held a stale pin,
// no safety-number compare step). The Decryptor calls `request` right after
// it forgave such a pin on the server's declared reset; App.vue subscribes
// via `onRequest` and shows the dialog. Remembered per account + reset time
// in localStorage so a second tab or a reload does not repeat it.

const seenKey = (accountId) => `nc1.resetNoticeSeen.${accountId}`

class Nc1ResetNoticeController {
  constructor () {
    this.onRequest = null
  }

  request ({ ownerEmail, accountId, at }) {
    if (!accountId) return
    const stamp = String(at || 'unknown')
    try {
      if (localStorage.getItem(seenKey(accountId)) === stamp) return
      localStorage.setItem(seenKey(accountId), stamp)
    } catch { /* storage unavailable: show it anyway */ }
    console.log(`[nc1] reset notice for ${ownerEmail} (reset at ${stamp})`)
    if (this.onRequest) {
      try { this.onRequest({ ownerEmail, accountId, at }) } catch (e) { console.log(e) }
    }
  }
}

export const Nc1ResetNotice = new Nc1ResetNoticeController()
